import _objectSpread from '@babel/runtime/helpers/objectSpread2';
import 'prop-types';
import * as React from 'react';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { UploaderBase } from './UploaderBase.js';
import { jsx } from 'react/jsx-runtime';

var Uploader = /*#__PURE__*/React.forwardRef(function Uploader2(props, ref) {
  return /*#__PURE__*/jsx(DndProvider, {
    backend: HTML5Backend,
    children: /*#__PURE__*/jsx(UploaderBase, _objectSpread(_objectSpread({}, props), {}, {
      ref: ref
    }))
  });
});
Uploader.displayName = "Uploader";

export { Uploader };
